import * as React from 'react';
const SelectableContext = /*#__PURE__*/React.createContext(null);
export const makeEventKey = function (eventKey) {
  let href = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (eventKey != null) return String(eventKey);
  return href || null;
};
export default SelectableContext;